import { createTheme } from '@mui/material/styles';

import type {} from '@mui/x-date-pickers/themeAugmentation';

// A custom theme for this app
export const theme = createTheme({
	typography: {
		fontFamily: 'Gotham Screen Smart',
		button: {
			textTransform: 'none',
		},
	},
	palette: {
		primary: {
			main: '#646464',
			light: '#F0F0F0',
			dark: '#000102',
		},
		secondary: {
			main: '#E5B9C0',
			light: '#F8F5F6',
			dark: '#CF0A2C',
		},
		success: {
			main: '#439B49',
			light: '#E1FAE7',
			dark: '#236027',
		},
		warning: {
			main: '#f26e02',
			light: '#fdf7f3',
			dark: '#a56d3e',
		},
		green: {
			main: '#006707',
			light: '#f9fdf7',
			dark: '#004a03',
			contrastText: '#fff',
		},
		yellow: {
			main: '#f2ba02',
			light: '#fffdf8',
			dark: '#a5903e',
			contrastText: '#222',
		},
		error: {
			main: '#B00020',
			light: '#FBEEEE',
			dark: '#932020',
		},
		offwhite: {
			main: '#f3f3f0',
			light: '#f9f9f6',
			contrastText: '#222',
		},
		accent: {
			main: '#305c76',
			light: '#c7d7e1',
			dark: '#1f3f53',
			contrastText: '#fff',
		},
		highlight: {
			main: '#0051a7',
			light: '#e6f0fa',
			dark: '#003d7a',
			contrastText: '#fff',
		},
		button: {
			main: '#222',
			contrastText: '#ddd',
		},
	},
	components: {
		MuiButton: {
			defaultProps: {
				color: 'button',
				disableElevation: true,
				variant: 'contained',
			},
		},
		MuiAppBar: {
			defaultProps: {
				elevation: 1,
			},
		},
		MuiOutlinedInput: {
			defaultProps: {
				size: 'small',
			},
		},
		MuiTab: {
			defaultProps: {
				disableRipple: true,
			},
		},
		MuiDateField: {
			defaultProps: {
				size: 'small',
			},
		},
		MuiCssBaseline: {
			styleOverrides: (theme) => `
				html,body { height: 100dvh; max-height: 100dvh; overflow: hidden }
				body { display: flex; flex-direction:column }
				#app { display: flex; flex: 1; flex-direction: column; background-color: ${theme.palette.offwhite.main} }
				form { display: flex; flex-direction: column; gap: ${theme.spacing(1.5)} }
				p { text-wrap: pretty }
				* { scrollbar-width: thin; }
			`,
		},
	},
});
